/*

   DO NOT REMOVE / NÃO REMOVER

   VERSÃO EM PORTUGUÊS MAIS ABAIXO

   
   BASIC LICENSE INFORMATION:

   Author: Claudemir Todo Bom
   Email: claudemir@todobom.com
   
   Licensed under the AGPLv3 as stated on LICENSE.md file
   
   Any work that uses code from this file is obligated to 
   give access to its source code to all of its users (not only
   the system's owner running it)
   
   EXCLUSIVE LICENSE to use on closed source derived work can be
   purchased from the author and put at the root of the source
   code tree as proof-of-purchase.



   INFORMAÇÕES BÁSICAS DE LICENÇA

   Autor: Claudemir Todo Bom
   Email: claudemir@todobom.com

   Licenciado sob a licença AGPLv3 conforme arquivo LICENSE.md
    
   Qualquer sistema que inclua este código deve ter o seu código
   fonte fornecido a todos os usuários do sistema (não apenas ao
   proprietário da infraestrutura que o executa)
   
   LICENÇA EXCLUSIVA para uso em produto derivado em código fechado
   pode ser adquirida com o autor e colocada na raiz do projeto
   como prova de compra. 
   
 */

import React, { useEffect, useState, useContext, useRef } from "react";

import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import Chip from "@material-ui/core/Chip";
import useSettings from "../../hooks/useSettings";
import { makeStyles } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";
import OnlyForSuperUser from "../OnlyForSuperUser";
import useAuth from "../../hooks/useAuth.js";

import {
  IconButton,
  InputAdornment,
  Typography,
} from "@material-ui/core";
import { SocketContext } from "../../context/Socket/SocketContext";

import { Colorize, AttachFile, Delete } from "@material-ui/icons";
import ColorPicker from "../ColorPicker";
import ColorModeContext from "../../layout/themeContext";
import api from "../../services/api";
import { getBackendURL } from "../../services/config";
import { i18nToast } from "../../helpers/i18nToast";
import { i18n } from "../../translate/i18n.js";
import { InputSwitch } from "../InputSwitch";
import NotificationSoundsManager from "../NotificationSoundsManager";
import {
  defaultExperimentalMenuItemKeys,
  sidebarMenuItems
} from "../../layout/experimentalMenuItems";

const defaultLogoLight = "/vector/logo.svg";
const defaultLogoDark = "/vector/logo-dark.svg";
const defaultLogoFavicon = "/vector/favicon.svg";

const useStyles = makeStyles((theme) => {
  return {
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    fixedHeightPaper: {
      padding: theme.spacing(2),
      display: "flex",
      overflow: "auto",
      flexDirection: "column",
      height: 240,
    },
    tab: {
      borderRadius: 4,
      width: "100%",
      "& .MuiTab-wrapper": {
        color: "#128c7e"
      },
      "& .MuiTabs-flexContainer": {
        justifyContent: "center"
      }


    },
    paper: {
      padding: theme.spacing(2),
      display: "flex",
      alignItems: "center",
      marginBottom: 12,
      width: "100%",
    },
    cardAvatar: {
      fontSize: "55px",
      color: grey[500],
      backgroundColor: "#ffffff",
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
    cardTitle: {
      fontSize: "18px",
      color: blue[700],
    },
    cardSubtitle: {
      color: grey[600],
      fontSize: "14px",
    },
    alignRight: {
      textAlign: "right",
    },
    fullWidth: {
      width: "100%",
    },
    selectContainer: {
      width: "100%",
      textAlign: "left",
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(0.5),
    },
    chip: {
      margin: 2,
    },
    colorAdorment: {
      width: 20,
      height: 20,
    },

    uploadInput: {
      display: "none",
    },

    appLogoLightPreviewDiv: {
      backgroundColor: "white",
      padding: "10px",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "#424242",
      textAlign: "center",
    },

    appLogoDarkPreviewDiv: {
      backgroundColor: "#424242",
      padding: "10px",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "white",
      textAlign: "center",
    },

    appLogoFaviconPreviewDiv: {
      padding: "10px",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "black",
      textAlign: "center",
    },

    appLogoLightPreviewImg: {
      width: "100%",
      maxHeight: 72,
      content: `url("${theme.calculatedLogoLight()}")`
    },

    appLogoDarkPreviewImg: {
      width: "100%",
      maxHeight: 72,
      content: `url("${theme.calculatedLogoDark()}")`
    },

    appLogoFaviconPreviewImg: {
      width: "100%",
      maxHeight: 72,
      content: `url("${((theme.appLogoFavicon) ? theme.appLogoFavicon : "/vector/favicon.svg")}")`
    },
    adPreviewImg: {
      width: "100%",
      maxHeight: 72,
      content: `url("${theme.appLogoAdImg || (theme.mode === "dark" ? theme.calculatedLogoDark() : theme.calculatedLogoLight())}")`
    }
  };
});

export default function Whitelabel(props) {
  const { settings } = props;
  const classes = useStyles();
  const [settingsLoaded, setSettingsLoaded] = useState({});

  const { getCurrentUserInfo } = useAuth();
  const [currentUser, setCurrentUser] = useState({});

  const { colorMode } = useContext(ColorModeContext);
  const socketManager = useContext(SocketContext);
  const [primaryColorLightModalOpen, setPrimaryColorLightModalOpen] = useState(false);
  const [primaryColorDarkModalOpen, setPrimaryColorDarkModalOpen] = useState(false);

  const [extensionUrl, setExtensionUrl] = useState("");
  const [buildingExtension, setBuildingExtension] = useState(false);

  const logoLightInput = useRef(null);
  const logoDarkInput = useRef(null);
  const logoFaviconInput = useRef(null);
  const logoAdImgInput = useRef(null);
  const appNameInput = useRef(null);
  const [appName, setAppName] = useState(settingsLoaded.appName || "");

  const [enableExperimental, setEnableExperimental] = useState(false);
  const [experimentalMenuItems, setExperimentalMenuItems] = useState(
    defaultExperimentalMenuItemKeys
  );
  const { getPublicSetting, update, updatePublicSetting } = useSettings();

  function updateSettingsLoaded(key, value) {
    const newSettings = { ...settingsLoaded };
    newSettings[key] = value;
    setSettingsLoaded(newSettings);
    console.debug(key, value, newSettings, settingsLoaded);
  }

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    if (!companyId) return;

    const socket = socketManager.GetSocket(companyId);

    const onExtensionBuild = data => {
      setBuildingExtension(false);
      if (data?.status === "success" && data?.url) {
        setExtensionUrl(data.url);
        i18nToast.success("whitelabel.extensionBuilt");
      } else {
        i18nToast.error(
          data?.message || i18n.t("whitelabel.extensionBuildUnknownError")
        );
      }
    };

    socket.on(`company-${companyId}-extensionBuild`, onExtensionBuild);

    return () => {
      socket.disconnect();
    };
  }, [socketManager]);

  useEffect(() => {
    getCurrentUserInfo().then(
      (u) => {
        setCurrentUser(u);
      }
    );

    console.debug("settings", settings);

    if (Array.isArray(settings) && settings.length) {
      const primaryColorLight = settings.find((s) => s.key === "primaryColorLight")?.value;
      const primaryColorDark = settings.find((s) => s.key === "primaryColorDark")?.value;
      const appLogoLight = settings.find((s) => s.key === "appLogoLight")?.value;
      const appLogoDark = settings.find((s) => s.key === "appLogoDark")?.value;
      const appLogoFavicon = settings.find((s) => s.key === "appLogoFavicon")?.value;
      const appLogoAdImg = settings.find((s) => s.key === "appLogoAdImg")?.value;
      const appName = settings.find((s) => s.key === "appName")?.value;
      const extensionDownloadUrl = settings.find(
        (s) => s.key === "extensionDownloadUrl"
      )?.value;
      setAppName(appName || "");
      setExtensionUrl(extensionDownloadUrl || "");
      setSettingsLoaded({ ...settingsLoaded, primaryColorLight, primaryColorDark, appLogoLight, appLogoDark, appLogoFavicon, appLogoAdImg, appName });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  useEffect(() => {
    let mounted = true;

    const loadExperimentalSettings = async () => {
      try {
        const [enabledValue, menuItemsValue] = await Promise.all([
          getPublicSetting("enableExperimental"),
          getPublicSetting("experimentalMenuItems")
        ]);

        if (!mounted) return;

        setEnableExperimental(
          enabledValue === "enabled" || enabledValue === "true"
        );

        if (menuItemsValue) {
          try {
            const parsedItems = JSON.parse(menuItemsValue);
            if (Array.isArray(parsedItems)) {
              setExperimentalMenuItems(parsedItems);
            }
          } catch {
            setExperimentalMenuItems(defaultExperimentalMenuItemKeys);
          }
        }
      } catch (error) {
        console.error("Erro ao carregar recursos experimentais:", error);
      }
    };

    loadExperimentalSettings();

    return () => {
      mounted = false;
    };
  }, [getPublicSetting]);

  useEffect(() => {
    const socket = socketManager.GetSocket();

    const onExperimentalSettings = (data) => {
      if (data?.key === "enableExperimental") {
        setEnableExperimental(
          data.value === "enabled" || data.value === "true"
        );
        return;
      }

      if (data?.key === "experimentalMenuItems") {
        try {
          const menuItems = JSON.parse(data.value);
          if (Array.isArray(menuItems)) {
            setExperimentalMenuItems(menuItems);
          }
        } catch {
          setExperimentalMenuItems(defaultExperimentalMenuItemKeys);
        }
      }
    };

    socket.on("experimentalSettings", onExperimentalSettings);

    return () => {
      socket.off("experimentalSettings", onExperimentalSettings);
    };
  }, [socketManager]);

  async function handleSaveSetting(key, value) {
    await update({
      key,
      value,
    });
    updateSettingsLoaded(key, value);
    i18nToast.success("settings.success");
  }

  const handleExperimentalMenuItemsChange = async (event) => {
    const value = event.target.value;

    try {
      await updatePublicSetting({
        key: "experimentalMenuItems",
        value: JSON.stringify(value)
      });
      setExperimentalMenuItems(value);
      i18nToast.success("settings.success");
    } catch (error) {
      console.error("Erro ao atualizar itens experimentais:", error);
      i18nToast.error("settings.error");
    }
  };

  const handleBuildExtension = async () => {
    setBuildingExtension(true);
    try {
      await api.post("/build-capture-extension");
      i18nToast.success("whitelabel.extensionBuildStarted");
    } catch (error) {
      setBuildingExtension(false);
      i18nToast.error("whitelabel.extensionBuildFailed");
    }
  };

  const uploadLogo = async (e, mode) => {
    if (!e.target.files) {
      return;
    }

    const file = e.target.files[0];
    const formData = new FormData();

    formData.append("file", file);
    formData.append("mode", mode);

    api.post("/settings/logo", formData, {
      onUploadProgress: (event) => {
        let progress = Math.round(
          (event.loaded * 100) / event.total
        );
        console.log(
          `A imagem  está ${progress}% carregada... `
        );
      },
    }).then((response) => {
      updateSettingsLoaded(`appLogo${mode}`, response.data);
      colorMode[`setAppLogo${mode}`](getBackendURL() + "/public/" + response.data);
    }).catch((err) => {
      console.error(
        `Houve um problema ao realizar o upload da imagem.`
      );
      console.log(err);
    });
  };

  return (
    <>
      <Grid spacing={3} container>
        {/* <Grid xs={12} item>
                    <Title>Configurações Gerais</Title>
                </Grid> */}
        <OnlyForSuperUser
          user={currentUser}
          yes={() => (
            <>
              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="primary-color-light-field"
                    label={i18n.t("whitelabel.primaryColorLight")}
                    variant="standard"
                    value={settingsLoaded.primaryColorLight || ""}
                    onClick={() => setPrimaryColorLightModalOpen(true)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <div
                            style={{ backgroundColor: settingsLoaded.primaryColorLight }}
                            className={classes.colorAdorment}
                          ></div>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <IconButton
                          size="small"
                          color="default"
                          onClick={() => setPrimaryColorLightModalOpen(true)}
                        >
                          <Colorize />
                        </IconButton>
                      ),
                    }}
                  />
                </FormControl>
                <ColorPicker
                  open={primaryColorLightModalOpen}
                  handleClose={() => setPrimaryColorDarkModalOpen(false)}
                  onChange={(color) => {
                    setPrimaryColorLightModalOpen(false);
                    handleSaveSetting("primaryColorLight", color);
                    colorMode.setPrimaryColorLight(color);
                  }}
                />
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="primary-color-dark-field"
                    label={i18n.t("whitelabel.primaryColorDark")}
                    variant="standard"
                    value={settingsLoaded.primaryColorDark || ""}
                    onClick={() => setPrimaryColorDarkModalOpen(true)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <div
                            style={{ backgroundColor: settingsLoaded.primaryColorDark }}
                            className={classes.colorAdorment}
                          ></div>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <IconButton
                          size="small"
                          color="default"
                          onClick={() => setPrimaryColorDarkModalOpen(true)}
                        >
                          <Colorize />
                        </IconButton>
                      ),
                    }}
                  />
                </FormControl>
                <ColorPicker
                  open={primaryColorDarkModalOpen}
                  handleClose={() => setPrimaryColorDarkModalOpen(false)}
                  onChange={(color) => {
                    setPrimaryColorDarkModalOpen(false);
                    handleSaveSetting("primaryColorDark", color);
                    colorMode.setPrimaryColorDark(color);
                  }}
                />
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="appname-field"
                    label={i18n.t("whitelabel.appname")}
                    variant="standard"
                    name="appName"
                    value={appName}
                    inputRef={appNameInput}
                    onChange={(e) => {
                      setAppName(e.target.value);
                    }}
                    onBlur={async (_) => {
                      await handleSaveSetting("appName", appName);
                      colorMode.setAppName(appName || "ticketz");
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="logo-light-upload-field"
                    label={i18n.t("whitelabel.lightLogo")}
                    variant="standard"
                    value={settingsLoaded.appLogoLight || ""}
                    InputProps={{
                      endAdornment: (
                        <>
                          {settingsLoaded.appLogoLight &&
                            <IconButton
                              size="small"
                              color="default"
                              onClick={() => {
                                handleSaveSetting("appLogoLight", "");
                                colorMode.setAppLogoLight(defaultLogoLight);
                              }
                              }
                            >
                              <Delete />
                            </IconButton>
                          }
                          <input
                            type="file"
                            id="upload-logo-light-button"
                            ref={logoLightInput}
                            className={classes.uploadInput}
                            onChange={(e) => uploadLogo(e, "Light")}
                          />
                          <label htmlFor="upload-logo-light-button">
                            <IconButton
                              size="small"
                              color="default"
                              onClick={
                                () => {
                                  logoLightInput.current.click();
                                }
                              }
                            >
                              <AttachFile />
                            </IconButton>
                          </label>
                        </>
                      ),
                    }}
                  />
                </FormControl>
                <div>
                  <Typography style={{ fontSize: "11px" }}>
                    {i18n.t("whitelabel.logoHint")}
                  </Typography>
                </div>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="logo-dark-upload-field"
                    label={i18n.t("whitelabel.darkLogo")}
                    variant="standard"
                    value={settingsLoaded.appLogoDark || ""}
                    InputProps={{
                      endAdornment: (
                        <>
                          {settingsLoaded.appLogoDark &&
                            <IconButton
                              size="small"
                              color="default"
                              onClick={() => {
                                handleSaveSetting("appLogoDark", "");
                                colorMode.setAppLogoDark(defaultLogoDark);
                              }
                              }
                            >
                              <Delete />
                            </IconButton>
                          }
                          <input
                            type="file"
                            id="upload-logo-dark-button"
                            ref={logoDarkInput}
                            className={classes.uploadInput}
                            onChange={(e) => uploadLogo(e, "Dark")}
                          />
                          <label htmlFor="upload-logo-dark-button">
                            <IconButton
                              size="small"
                              color="default"
                              onClick={
                                () => {
                                  logoDarkInput.current.click();
                                }
                              }
                            >
                              <AttachFile />
                            </IconButton>
                          </label>
                        </>
                      ),
                    }}
                  />
                </FormControl>
                <div>
                  <Typography style={{ fontSize: "11px" }}>
                    {i18n.t("whitelabel.logoHint")}
                  </Typography>
                </div>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="logo-favicon-upload-field"
                    label={i18n.t("whitelabel.favicon")}
                    variant="standard"
                    value={settingsLoaded.appLogoFavicon || ""}
                    InputProps={{
                      endAdornment: (
                        <>
                          {settingsLoaded.appLogoFavicon &&
                            <IconButton
                              size="small"
                              color="default"
                              onClick={() => {
                                handleSaveSetting("appLogoFavicon", "");
                                colorMode.setAppLogoFavicon(defaultLogoFavicon);
                              }
                              }
                            >
                              <Delete />
                            </IconButton>
                          }
                          <input
                            type="file"
                            id="upload-logo-favicon-button"
                            ref={logoFaviconInput}
                            className={classes.uploadInput}
                            onChange={(e) => uploadLogo(e, "Favicon")}
                          />
                          <label htmlFor="upload-logo-favicon-button">
                            <IconButton
                              size="small"
                              color="default"
                              onClick={
                                () => {
                                  logoFaviconInput.current.click();
                                }
                              }
                            >
                              <AttachFile />
                            </IconButton>
                          </label>
                        </>
                      ),
                    }}
                  />
                </FormControl>
                <div>
                  <Typography style={{ fontSize: "11px" }}>
                    {i18n.t("whitelabel.faviconHint")}
                  </Typography>
                </div>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <div className={classes.appLogoLightPreviewDiv}>
                  <img className={classes.appLogoLightPreviewImg} alt="light-logo-preview" />
                </div>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <div className={classes.appLogoDarkPreviewDiv}>
                  <img className={classes.appLogoDarkPreviewImg} alt="dark-logo-preview" />
                </div>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <div className={classes.appLogoFaviconPreviewDiv}>
                  <img className={classes.appLogoFaviconPreviewImg} alt="favicon-preview" />
                </div>
              </Grid>

              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="ad_img-upload-field"
                    label="Ad Imagem"
                    variant="standard"
                    value={settingsLoaded.appLogoAdImg || ""}
                    InputProps={{
                      endAdornment: (
                        <>
                          {settingsLoaded.appLogoAdImg &&
                            <IconButton
                              size="small"
                              color="default"
                              onClick={() => {
                                handleSaveSetting("appLogoAdImg", "");
                                colorMode.setAppLogoAdImg("");
                              }
                              }
                            >
                              <Delete />
                            </IconButton>
                          }
                          <input
                            type="file"
                            id="upload-Ad-Img-button"
                            ref={logoAdImgInput}
                            className={classes.uploadInput}
                            onChange={(e) => uploadLogo(e, "AdImg")}
                          />
                          <label htmlFor="upload-Ad-Img-button">
                            <IconButton
                              size="small"
                              color="default"
                              onClick={
                                () => {
                                  logoAdImgInput.current.click();
                                }
                              }
                            >
                              <AttachFile />
                            </IconButton>
                          </label>
                        </>
                      ),
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid xs={12} sm={6} md={4} item>
                <div className={classes.appLogoFaviconPreviewDiv}>
                  <img className={classes.adPreviewImg} alt="AdImg-preview" />
                </div>
              </Grid>

              <Grid xs={12} item>
                <Typography variant="h6" gutterBottom>
                  Recursos experimentais
                </Typography>
                <Grid container spacing={2} alignItems="flex-start">
                  <Grid xs={12} md={4} item>
                    <InputSwitch
                      label="Ativar recursos experimentais"
                      name="enableExperimental"
                      id="enableExperimental"
                      checked={enableExperimental}
                      onChange={async (e) => {
                        const value = e.target.checked ? "enabled" : "disabled";

                        try {
                          await updatePublicSetting({
                            key: "enableExperimental",
                            value
                          });
                          setEnableExperimental(e.target.checked);
                          i18nToast.success("settings.success");
                        } catch (error) {
                          console.error("Erro ao atualizar recursos experimentais:", error);
                          i18nToast.error("settings.error");
                        }
                      }}
                    />
                    <Typography style={{ fontSize: "11px", marginTop: "4px" }}>
                      Exibe os itens selecionados abaixo para todas as empresas.
                    </Typography>
                  </Grid>
                  <Grid xs={12} md={8} item>
                    <FormControl className={classes.selectContainer} variant="standard">
                      <InputLabel id="experimental-menu-items-label">
                        Itens do menu lateral considerados experimentais
                      </InputLabel>
                      <Select
                        labelId="experimental-menu-items-label"
                        id="experimental-menu-items"
                        multiple
                        value={experimentalMenuItems}
                        onChange={handleExperimentalMenuItemsChange}
                        renderValue={(selected) => (
                          <div className={classes.chips}>
                            {selected.map((key) => {
                              const item = sidebarMenuItems.find((i) => i.key === key);
                              return (
                                <Chip
                                  key={key}
                                  label={item?.label || key}
                                  className={classes.chip}
                                />
                              );
                            })}
                          </div>
                        )}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 320,
                              width: 320
                            }
                          }
                        }}
                      >
                        {sidebarMenuItems.map((item) => (
                          <MenuItem key={item.key} value={item.key}>
                            <Checkbox
                              color="primary"
                              checked={experimentalMenuItems.includes(item.key)}
                            />
                            <ListItemText primary={item.label} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid xs={12} item>
                <NotificationSoundsManager />
              </Grid>

              <Grid xs={12} item>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                    flexWrap: "wrap",
                    marginTop: 16
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={buildingExtension}
                    onClick={handleBuildExtension}
                  >
                    {buildingExtension
                      ? i18n.t("whitelabel.buildingExtension")
                      : i18n.t("whitelabel.buildExtension")}
                  </Button>
                  {extensionUrl && (
                    <Button
                      variant="outlined"
                      color="primary"
                      href={`${getBackendURL()}/public/${extensionUrl}`}
                      target="_blank"
                      rel="noopener"
                    >
                      {i18n.t("whitelabel.downloadExtension")}
                    </Button>
                  )}
                </div>
                <Typography style={{ fontSize: "11px", marginTop: "4px" }}>
                  {i18n.t("whitelabel.extensionHint")}
                </Typography>
              </Grid>
            </>
          )}
        />
      </Grid>
    </>
  );
}